<template>
  <div class="index" style="padding-top:0.4rem">
    <section class="mod nav-new-gd">
      <div class="nav2 navSticky">
        <!-- <div class="nav2-wrap flex">
          <span v-for="(nav,i) in subNavs" :key="i" :class="curSubNav==i?'cur':''" @click="checkJiGouDetail(i)">{{nav}}</span>
        </div> -->
      </div>
      <div class="table-scroll table-scroll-h">
        <div class="table_first">
        <div class="date_box fl"><span>名称代码</span></div>
        <div class="right_box" id="rightTitle">
          <div>
            <span>持仓市值</span>
            <span>持仓量</span>
            <span>持仓占比</span>
            <span>所属板块</span>
          </div>
        </div>
      </div>
        <div class="table-l fl">
          <table width="100%" cellspacing="0" cellpadding="0">
            <!-- <tr><th>名称代码</th></tr> -->
            <tr v-for="item in stockList" :key="item.id" @click="goToJgChartDetail(item.stockcode)">
              <td>{{item.sesname}}<small>{{item.stockcode}}</small></td>
            </tr>
          </table>
        </div>
        <div class="table-r" id="right">
          <div class="table-r-wrap table-r-wrap3">
            <table width="100%" cellspacing="0" cellpadding="0">
              <!-- <tr><th>持仓市值</th><th>持仓量</th><th>持仓占比</th><th>所属板块</th></tr> -->
              <tr v-for="item in stockList" :key="item.id" @click="goToJgChartDetail(item.stockcode)">
                <td>{{item.holdamt | num(["元","万","亿", "万亿"],'元')}}</td>
                <td>{{item.holdvol | num(["","万","亿", "万亿"],'')}}</td>
                <td :class="item.holdratio|formateRedGreen">{{(item.holdratio * 100 ).toFixed(2)}}%</td>
                <td>{{item.bkmc}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {  jiGouDetail } from '@/api/xqDetail.js'
import { getUrlQuery } from "@/utils/handleUrl.js"
export default {
    name: "jgMore",
    components: {},
    data() {
        return {
          curSubNav:0,
          stockCode:"",// 股票代码
          userToken:"",// 用户token
          version:"",// 客户端版本号
          type:"",// 手机类型
          subNavs:['全部','昨日新建','昨日增持','昨日减持'],
          stockList:[],
          page: 1,
          pageSize: 20,
          queryShow:false,//判断请求是否完成
          allQuery:false,//判断是否已请求全部数据
        };
    },
    filters: {
      formateRedGreen:function (v) {
        if(v==undefined||v==null) return
        if(v>0) return 'ft-red'
        if(v<0) return 'ft-green'
      },
      num(num,arr,type) {
        if (!num && num !== 0) {
          return "";
        } else {
          let str = Number(num);
          if (num > 0) {
            let param = {};
            let k = 10000;
            let sizes = arr;
            let i;
            if (num < k) {
              param.value = num;
              param.unit = type;
            } else {
              i = Math.floor(Math.log(num) / Math.log(k));
              param.value = (num / Math.pow(k, i)).toFixed(2);
              param.unit = sizes[i];
            }
            return parseFloat(param.value.toString()).toFixed(2) + param.unit;
          } else if (num < 0) {
            let param = {};
            let k = 10000;
            let sizes =  arr;
            let i;
            num = -num;
            if (num < k) {
              param.value = -num;
              param.unit = type;
            } else {
              i = Math.floor(Math.log(num) / Math.log(k));
              param.value = -(num / Math.pow(k, i)).toFixed(2);
              param.unit = sizes[i];
            }
            return parseFloat(param.value.toString()).toFixed(2) + param.unit;
          } else if (num === 0) {
            return 0.0;
          }
          return parseFloat(str).toFixed(2);
        }
      },
    },
    created() {
      this.stockCode = getUrlQuery('code')
      this.userToken = getUrlQuery('token')
      this.version = getUrlQuery('version')
      this.name = decodeURIComponent(getUrlQuery('name'));
      let u = navigator.userAgent;
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      if(isiOS){
        this.type = 'ios'
      }else if(isAndroid){
        this.type = 'android'
      }
    },
    mounted: function () {
      window.addEventListener('scroll', this.scrollChange, true)
      let right = document.getElementById("right");
        right.onscroll = function () {
          let right_left = this.scrollLeft;
          console.log(right_left)
          document.getElementById("rightTitle").scrollLeft = right_left;
          console.log(document.getElementById("rightTitle").scrollLeft)
        };
      this.getJiGouDetail()
    },
    methods: {
      // 持股明细切换
      checkJiGouDetail:function(i){
        if(this.queryShow) return;
        this.curSubNav=i;
        this.page = 1;
        this.stockList = [];
        this.allQuery = false;
        this.$nextTick(()=>{
          this.getJiGouDetail()
        })
      },
      // 持股明细
      getJiGouDetail: function(){
        let that= this;
        if(that.queryShow) return;
        that.queryShow = true;
        let obj = {
          token:that.userToken,
          httpdzh:that.version?'dzh-'+that.type+'-'+that.version:'',
          particode:that.stockCode,
          holdtype:that.curSubNav,
          pageNumber:that.page,
          pageSize:that.pageSize,
        }
        jiGouDetail(obj).then(res=>{
          that.queryShow = false;
          if(res.data.err === 0){
            that.stockList = [...that.stockList ,...res.data.data.list];
            if(res.data.data.list.length < 20){
              that.allQuery = true;
            }
          }
        })
      },
      scrollChange () {
        let that = this;
        var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
        var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
        if(scrollTop+windowHeight>=scrollHeight){
          if(!that.queryShow && !that.allQuery){
            that.page = that.page + 1
            this.$nextTick(()=>{
            that.getJiGouDetail()
            })
          }
        }
      },


    /**
     * 调转到 持股明细详情
     * @param {string} stockcode 股票代码
     * 这和 this.stockCode 是两个不同的值，分别代表不同意思。
     * 持股明细详情 路由是：/jgchartdetail/?code={$particode}&stockCode={$stockcode}&name={compname}
     * @author zhangrongzong@gw.com.cn
     */
     goToJgChartDetail:function(stockcode){
      let that = this;
      if(stockcode == null || stockcode == ""){
         return;
      }
      if(that.stockCode == null || that.stockCode == ""){
         return;
      }
      let paramsStr = '#/jgchartdetail?code='+that.stockCode+'&stockCode='+ stockcode+'&name='+that.name;
      location.href=window.location.protocol+"//"+window.location.host + window.location.pathname + paramsStr;

     },


    },

    destroyed () {
      // 离开该页面需要移除这个监听的事件，不然会报错
      window.removeEventListener('scroll', this.scrollChange, true)
    }
};
</script>
